import React from 'react';
const Example = () => (<div>
        <div className="p-6 mb-4 fs-base">.fs-base</div>
        <div className="p-6 mb-4 fs-h1">.fs-h1</div>
        <div className="p-6 mb-4 fs-h2">.fs-h2</div>
        <div className="p-6 mb-4 fs-h3">.fs-h3</div>
        <div className="p-6 mb-4 fs-h4">.fs-h4</div>
        <div className="p-6 mb-4 fs-h5">.fs-h5</div>
        <div className="p-6 mb-4 fs-h6">.fs-h6</div>
    </div>);
export default Example;
